import { clientId } from "./constants";
import "./propertyRenderers";
import "./appLinks";
import "./ticketViews";

export const shopFloorWalkRoutes = [
  {
    path: "/shop-floor-walk",
    name: "sfwDashboardList",
    component: () => import("@shared/shopFloorWalk/views/SFWDashboard.vue"),
  },
  {
    path: "/shop-floor-walk/:dashboardId",
    name: "sfwDashboardDetail",
    props: true,
    component: () =>
      import("@shared/shopFloorWalk/views/SFWDashboardDetail.vue"),
  },
  {
    path: "/sfw-assets",
    name: "sfwAssets",
    component: () => import("@shared/shopFloorWalk/views/SFWAssetListView.vue"),
  },
  {
    path: "/sfw-assets/:template/edit/:id?",
    name: "sfwAssetDetail",
    props: true,
    component: () =>
      import("@shared/shopFloorWalk/views/SFWAssetDetailView.vue"),
  },
  {
    path: "/sfw-walkthrough",
    name: "sfwWalkThrough",
    component: () =>
      import("@shared/shopFloorWalk/views/SFWWalkThroughView.vue"),
  },
  {
    path: "/sfw-walk-history",
    name: "sfwOrderHistory",
    component: () => import("@shared/shopFloorWalk/views/SFWOrderListView.vue"),
  },
  {
    path: "/sfw-walk-history/:template/edit/:id?",
    name: "sfwOrderHistoryDetail",
    props: true,
    component: () => import("@shared/shopFloorWalk/views/SFWOrderDetail.vue"),
  },
  {
    path: "/sfw-tickets/my-tickets",
    name: "sfwMyTickets",
    component: () => import("@shared/shopFloorWalk/views/SFWMyTickets.vue"),
    meta: {
      appClientId: clientId,
    },
  },
  {
    path: "/sfw-tickets/create",
    name: "sfwTicketCreate",
    component: () => import("@shared/shopFloorWalk/views/SFWTicketCreate.vue"),
    meta: {
      appClientId: clientId,
    },
  },
  {
    path: "/sfw-tickets/search",
    name: "sfwTicketSearch",
    component: () => import("@shared/shopFloorWalk/views/SFWTicketSearch.vue"),
    meta: {
      appClientId: clientId,
    },
  },
  {
    path: "/sfw-tickets/:id",
    name: "sfwTicketDetail",
    props: true,
    component: () => import("@shared/shopFloorWalk/views/SFWTicketDetail.vue"),
    meta: {
      appClientId: clientId,
    },
  },
  {
    path: "/sfw-tickets/:id/history",
    name: "sfwTicketHistory",
    props: true,
    component: () => import("@shared/shopFloorWalk/views/SFWTicketHistory.vue"),
    meta: {
      appClientId: clientId,
    },
  },
];
